import React from 'react'
import Layout from './layout/Layout'
import ScrollToTop from '../ScrollToTop'
import Helmet from 'react-helmet'
import EnquireNowSection from './views/EnquireNowSection'

class ContactThankyou extends React.Component {
    render(){
        return(
            <Layout>
                <Helmet>
                    <title>Contact Us Thankyou | Graham and Rhona Beck Skills Centre</title>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ScrollToTop />
                <section className='_section _section-contact _section-top-no-banner'>
                    <div className='_grid'>
                        <div className='_column'>
                            <h1 className='_heading-3 _gold'>Message Sent</h1>
                            <p>Thank you for your message. A consultant will be in touch with you soon.</p>
                        </div>
                    </div>
                </section>

                <EnquireNowSection />
            </Layout>
        )
    }
}

export default ContactThankyou